// 'use client';
// import { useEffect } from 'react';
// import GoftinoWidget from './GoftinoWidget';

// export default function ClientScripts() {
//   useEffect(() => {
//     // در صورت نیاز به js بوت‌استرپ آن را داینامیک ایمپورت می‌کنیم
//     import('bootstrap/dist/js/bootstrap').catch(() => {
//       // اگر بارگذاری شد یا نشد، برنامه نباید کرش کند
//     });
//   }, []);

//   return <GoftinoWidget />;
// }



'use client';
import { useEffect } from 'react';
// import GoftinoWidget from './GoftinoWidget'; // حذف کن اگر استفاده نمی‌کنی

export default function ClientScripts() {
  useEffect(() => {
    import('bootstrap/dist/js/bootstrap').catch(() => {});
  }, []);

  return null; // یا return <></>;
}